import FormShell from "../../Organisms/FormShell/FormShell";
import HomeAboutForesightSection from "../../Organisms/HomeAboutForesightSection/HomeAboutForesightSection";
import HomeBenefitsSection from "../../Organisms/HomeBenefitsSection/HomeBenefitsSection";
import LogosSection from "../../Organisms/LogosSection/LogosSection";
import HomePlataformaSection from "../../Organisms/HomePlataformaSection/HomePlataformaSection";
import HomeCaracteristicasSection from "../../Organisms/HomeCaracteristicasSection/HomeCaracteristicasSection";
// import PageHeader from "../../Molecules/PageHeader/PageHeader";
import DynamicFormik from "../../Organisms/DynamicFormik/DynamicFormik";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

export const Home = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();
	const formikFields = [
		{
			title: content[language].formikField_1,
			requestKey: "nombre_apellido",
		},
		{
			title: content[language].formikField_2,
			requestKey: "email",
		},
		{
			title: content[language].formikField_3,
			requestKey: "pais",
		},
		{
			title: content[language].formikField_4,
			requestKey: "compañia",
		},
		{
			title: content[language].formikField_5,
			requestKey: "ciudad",
		},
		{
			title: content[language].formikField_6,
			requestKey: "tamaño_flota",
			type: "number",
		},
		{
			title: content[language].formikField_7,
			requestKey: "como_se_entero",
		},
	];

	return (
		<>
			<ChangeableHeaderV2
				withBanner
				appearSecondNavbar={dropdownHeader}
			/>
			<HomeAboutForesightSection />
			<HomeBenefitsSection />
			<HomePlataformaSection />
			<HomeCaracteristicasSection />
			<LogosSection route="home" />
			<FormShell home title={content[language].formTitle} route="home">
				<DynamicFormik
					buttonContent={content[language].formButtonText}
					field_1={formikFields[0]}
					field_2={formikFields[1]}
					field_3={formikFields[2]}
					field_4={formikFields[3]}
					field_5={formikFields[4]}
					field_6={formikFields[5]}
					field_7={formikFields[6]}
				/>
			</FormShell>
		</>
	);
};
